import React from 'react'

import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'

const withMutation = WrappedComponent => {
  return props => {
    const {
      onMutationCompleted, // via withFormResults
      onMutationError // via withFormResults
    } = props

    const [savePayment, { loading, error }] = useMutation(mutation, {
      onError: onMutationError,
      onCompleted: onMutationCompleted
    })

    return (
      <WrappedComponent
        savePayment={savePayment}
        mutationLoading={loading}
        error={error}
        {...props}
      />
    )
  }
}

export default withMutation
